// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"35":"a65b904bfbb71c2e","185":"a446274be0928eaf"}[chunkId] + ".css";
};